import { Text, Tooltip } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import {
    formatTimeSince,
    formatUtcTimestamp,
    parseUtcTimestamp,
} from './helpers/timeSince';

const REFRESH_MS = 60 * 1000;

/**
 * (3158) When an app auth was last health checked, as time since ("12 mins
 * ago"), kept current every minute. Hovering shows the exact time; with no
 * check at all it reads "Never".
 *
 * @param {object} props
 * @param {string} [props.timestamp] - UTC, from the app auth record
 */
const LastHealthCheck = ({ timestamp }) => {
    const { darkMode } = useSelector((state) => state.settings);
    const time = parseUtcTimestamp(timestamp);
    const [now, setNow] = useState(() => Date.now());

    useEffect(() => {
        if (time === null) return undefined;
        setNow(Date.now());
        const timer = setInterval(() => setNow(Date.now()), REFRESH_MS);
        return () => clearInterval(timer);
    }, [time]);

    return (
        <Tooltip
            hasArrow
            isDisabled={time === null}
            label={time === null ? '' : formatUtcTimestamp(time)}
            placement="bottom">
            <Text
                as="span"
                fontSize="xs"
                minW={0}
                noOfLines={1}
                marginBottom={0}
                color={darkMode ? 'gray.400' : 'gray.500'}>
                Last Health Check:{' '}
                {time === null ? 'Never' : formatTimeSince(time, now)}
            </Text>
        </Tooltip>
    );
};

export default LastHealthCheck;
